import cx from "classnames";
import { useShallow } from "zustand/react/shallow";

import { type MainNavigationMenuItem } from "components/MainNavigation/types";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import useMainNavigationActiveStates from "components/MainNavigation/hooks/useActiveStates";
import Box from "ds/components/Box";
import { selectNavigationIsExpanded } from "components/MainNavigation/selectors/navigationState";
import MainNavigationBaseActionLink from "components/MainNavigation/components/atoms/BaseAction/Link";
import MainNavigationCounter from "components/MainNavigation/components/atoms/Counter";
import MainNavigationBetaIndicator from "components/MainNavigation/components/atoms/BetaIndicator";
import MainNavigationPinAction from "components/MainNavigation/components/atoms/PinAction";

import styles from "./styles.module.css";

type MainNavigationGroupMenuItemProps = {
  item: MainNavigationMenuItem;
  className?: string;
};

const MainNavigationGroupMenuItem = ({ item, className }: MainNavigationGroupMenuItemProps) => {
  const { isSidebarExpanded, itemCounts } = useMainNavigationStore(
    useShallow((state) => ({
      isSidebarExpanded: selectNavigationIsExpanded(state),
      itemCounts: state.itemCounts,
    }))
  );

  const { activeMenuItemId } = useMainNavigationActiveStates();
  const isActive = item.id === activeMenuItemId;
  const itemCount = itemCounts[item.id] || 0;

  return (
    <Box fullWidth relative className={styles.container}>
      <MainNavigationBaseActionLink
        id={item.htmlId}
        to={item.to}
        href={item.href}
        onClick={item.onAction}
        title={item.title}
        isActive={isActive}
        className={cx(styles.menuItem, className)}
        isSidebarExpanded={isSidebarExpanded}
      >
        {item.beta ? (
          <MainNavigationBetaIndicator className={styles.counter} />
        ) : (
          <MainNavigationCounter count={itemCount} inversed={isActive} className={styles.counter} />
        )}
      </MainNavigationBaseActionLink>

      {isSidebarExpanded && <MainNavigationPinAction item={item} className={styles.pin} />}
    </Box>
  );
};

export default MainNavigationGroupMenuItem;
